"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AssignmentCardV2_1 = tslib_1.__importDefault(require("src/modules/references/employees/views/assignment/AssignmentCardV2"));
const AssignmentCardsV2 = ({ el, assignHook, index, sidebarHook, districtsCanCreate }) => {
    const [cardOpen, setCardOpen] = (0, react_1.useState)([]);
    const [correcting, setCorrecting] = (0, react_1.useState)(null);
    return ((0, jsx_runtime_1.jsx)("div", { className: 'card card-custom border border-primary', children: (0, jsx_runtime_1.jsx)("div", { className: 'card-header mt-2 flex-column', children: (0, jsx_runtime_1.jsx)(AssignmentCardV2_1.default, { isOriginal: true, index: index, setCorrecting: setCorrecting, assignHook: assignHook, assignment: el, districtsCanCreate: districtsCanCreate, sidebarHook: sidebarHook, parentAssignment: el, cardOpen: cardOpen, setCardOpen: setCardOpen, correcting: correcting }) }) }));
};
exports.default = AssignmentCardsV2;
